export class RequestError extends Error {
	data: unknown;

	constructor(message: string, data: unknown) {
		super(message);

		this.data = data;
	}
}
